<div appTheme>
    <div *ngIf="!isResetLinkValid">
        <div class="modal-box scrolling">
            <div class="col-sm-6 main-container">
                <h1>Reset Password</h1>
                <div class="col-sm-12">
                    <p class="error-message">{{errorMessage}}</p>
                </div>
            </div>
        </div>
    </div>
    <form *ngIf="isResetLinkValid" (ngSubmit)="onResetPassword(f)" #f="ngForm">
        <div class="modal-box scrolling">
            <div class="col-sm-6 main-container">
                <h1>Reset Password</h1>
                <div class="col-sm-12">
                    <p>Enter your new password.</p>
                    <p class="error-message">{{errorMessage}}</p>
                    <div class="row">
                        <div class="col-sm-6">
                            <input
                                class="input-text"
                                type="password"
                                name="userPassword"
                                [ngModel]="userPassword"
                                placeholder="Password"
                                userPassword
                                required
                                minlength="8"
                                maxlength="50"
                                #passwordRef="ngModel"
                            />
                            <br>
                            <span class="help-block" *ngIf="!passwordRef.valid && passwordRef.touched">{{this.passwordMsg}}</span>
                        </div>
                        <div class="col-sm-6">
                            <input
                                class="input-text"
                                type="password"
                                name="userConfirmPassword"
                                [ngModel]="userConfirmPassword"
                                placeholder="Confirm Password"
                                userConfirmPassword
                                required
                                maxlength="50"
                                #confirmPasswordRef="ngModel"
                            />
                            <span class="help-block" *ngIf="passwordRef.valid && !confirmPasswordRef.valid">Please enter a confirm password.</span>
                            <span class="help-block" *ngIf="confirmPasswordRef.valid && passwordRef.valid && confirmPasswordRef.value != passwordRef.value">Passwords do not match.</span>
                        </div>
                    </div>
                    <div class="bottom">
                        <button class="submit-button button-small" id="submitBtn" [disabled]="!f.valid">
                            Submit <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                        <button class="cancel-button button-small" id="cancelBtn" (click)="goToMain()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-box scrolling" *ngIf="showResetPasswordSuccess">
        <div class="modal-box-container-result main-container">
            <p>Your new password has been set successfully. </p>
            <div class="bottom">
                <div class="submit-button ok-button" (click)="goToLogin()">Ok</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading [text]="'Resetting password...'" [size]="'fa-5x'"></app-loading>
</div>
